<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="16.5" viewBox="0 0 16.5 16.5" fill="none">
		<path d="M0.75 0.75H15.75" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
		<path d="M0.75 5.75H15.75" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
		<path d="M0.75 10.75H15.75" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
		<path d="M0.75 15.75H15.75" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'TextAreaIcon',
	props: {
		color: {
			type: String,
			default: '#2e3a50',
		},
	},
});
</script>
